import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";

export const Voucher_File_manager = async (data) => {
  const { title,description, voucherid,fileid} = data || {};
 const servicetablename = "accountingfinancedb";
  // Validation
 
 
  if (!voucherid?.trim()) {
    return { success: false, error: "Missing voucherid " };
  }
    if (!title?.trim()) {
    return { success: false, error: "Missing title " };
  }
    if (!description?.trim()) {
    return { success: false, error: "Missing description " };
  }
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    
    // Create ledger under company
  

    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      "voucher_file_manager",
      fileid
    );

    const savequery = {
      ...data,
      
      companyuid: select_company_uid,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(parentDocRef, savequery);

    return { success: true };
  } catch (err) {
    console.error("Error saving ledger:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
